import { render, staticRenderFns } from "./AAARecordForm.vue?vue&type=template&id=b6544eb2&"
import script from "./AAARecordForm.vue?vue&type=script&lang=js&"
export * from "./AAARecordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6544eb2')) {
      api.createRecord('b6544eb2', component.options)
    } else {
      api.reload('b6544eb2', component.options)
    }
    module.hot.accept("./AAARecordForm.vue?vue&type=template&id=b6544eb2&", function () {
      api.rerender('b6544eb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Domains/ZoneEditor/Records/AAARecordForm.vue"
export default component.exports